const photobashingLundbeck = {
  href: "/portfolio/photobashing-lundbeck/",
  img: "/assets/images/lundbeck_featureImg.jpg",
  title: "Photobashing - Lundbeck",
  description: "Design work for H. Lundbeck A/S"
};

export default photobashingLundbeck;